import { FormEvent, useContext, useEffect, useState } from 'react'
import { Button, Loader } from '../Styles'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import "./index.css"
import { PropsMatrizPriorizacao } from '../../interfaces/desafios'
import { atualizarMatrizGut, criarMatrizGut } from '../../services/desafios'
import { toast } from 'react-toastify'
import { criptografarDado, descriptografarDado } from '../../helpers'
import { useLocation } from 'react-router-dom';

function MatrizPriorizacao({ desafio }: PropsMatrizPriorizacao) {
  const { modalExibir, atualizarDados } = useContext(ModalEstadoContext)

  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto");

  const [processando, setProcessando] = useState(false);
  const [gravidade, setGravidade] = useState<number>(desafio.matrizGut?.gravidade || 1);
  const [urgencia, setUrgencia] = useState<number>(desafio.matrizGut?.urgencia || 1);
  const [tendencia, setTendencia] = useState<number>(desafio.matrizGut?.tendencia || 1);
  const [prioridade, setPrioridade] = useState<number>(desafio.matrizGut?.prioridade || 3);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setProcessando(true)
    try {
      if (!idProjeto) return toast.error("Projeto não encontrado");
      const idProjetoDescript = descriptografarDado(idProjeto)

      const payload = {
        urgencia, tendencia, gravidade, idProjeto: parseInt(idProjetoDescript), idDesafio: desafio.id
      }
      const resposta = await criarMatrizGut(payload)

      if (resposta.status === 201) {
        setProcessando(false);
        modalExibir("")
        toast.success("Matriz Criado com Sucesso.")
        atualizarDados()
      }
    } catch (error) {
      setProcessando(false)
      toast.error("Erro ao Cadastrar Matriz.")
    }
  }

  const handleUpdate = async (e: FormEvent) => {
    e.preventDefault()
    try {
      if (!idProjeto) return toast.error("Projeto não encontrado");
      if (!desafio.matrizGut) return toast.error("Matriz não encontrada.");
      const idMatrizGutCript = criptografarDado(desafio.matrizGut.id.toString())
      const payload = {
        urgencia, tendencia, gravidade
      }
      const resposta = await atualizarMatrizGut(idMatrizGutCript, payload)

      if (resposta.status === 200) {
        setProcessando(false);
        modalExibir("")
        toast.success("Matriz Atualizado com Sucesso.")
        atualizarDados()
      }
    } catch (error) {
      setProcessando(false)
      toast.error("Erro ao Atualizar Matriz.")
    }
  }

  useEffect(() => {
    let somaGut = gravidade * urgencia * tendencia

    setPrioridade(somaGut)
  }, [gravidade, urgencia, tendencia])

  return (
    <div id='fundoModal'>
      <form className={'containerModalCentro'} onSubmit={(e) => desafio.matrizGut?.id ? handleUpdate(e) : handleSubmit(e)}>
        <span className='novoContainerTitulo'>
          <h1>{desafio.matrizGut ? "Atualizar" : "Cadastrar"} Matriz de GUT</h1>
        </span>

        <section className="formModalMatriz">
          <section>
            <div className='matriz-pergunta'>
              <label htmlFor="">Gravidade</label>
              <select name="" id="" onChange={(e) => { setGravidade(parseInt(e.target.value)) }} defaultValue={gravidade} className='select-matriz'>
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={3}>3</option>
                <option value={4}>4</option>
                <option value={5}>5</option>
              </select>
            </div>
          </section>
          <section>
            <div className='matriz-pergunta'>
              <label htmlFor="">Tendencia</label>
              <select name="" id="" onChange={(e) => { setTendencia(parseInt(e.target.value)) }} defaultValue={tendencia} className='select-matriz'>
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={3}>3</option>
                <option value={4}>4</option>
                <option value={5}>5</option>
              </select>
            </div>
          </section>
          <section>
            <div className='matriz-pergunta'>
              <label htmlFor="">Urgência</label>
              <select name="" id="" onChange={(e) => { setUrgencia(parseInt(e.target.value)) }} defaultValue={urgencia} className='select-matriz'>
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={3}>3</option>
                <option value={4}>4</option>
                <option value={5}>5</option>
              </select>
            </div>
          </section>
          <section className='container-prioridade'>
            <span className='media-prioridade'>
              <p>Prioridade: {prioridade}</p>
            </span>
          </section>
        </section>
        <span className="botoesContainer">
          <Button type="button" cor="cancelar" isLoading={processando} onClick={() => modalExibir("")}>
            Cancelar
          </Button>
          <Button type="submit" cor="salvar" isLoading={processando}>
            {!processando && "Salvar"}
            {processando && <Loader isLoading={processando} />}
          </Button>
        </span>
      </form>
    </div>
  )
}

export default MatrizPriorizacao